export default __webpack_public_path__ + "static/hk-4dc67cd58c4c3b7f8c208bc84c8ccb5a.svg";